import React, { useEffect } from 'react'

// components
import { SelectPicker } from 'rsuite'
import Icon from './Icon'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { getOptions, getContextOptions, getYou, getFavourites } from '../redux/options/selectors'
import { isFavourite, isInGroup } from '../tools/Favourites'
import { setOption } from '../redux/options/actions' 
import { getCarsDetails } from '../redux/data/selectors' 
import CarLogo from './CarLogo';

const CarDropdown = ( { showAll = true, context = 'filters', onChange = null } ) =>
{
  // redux
  const dispatch = useDispatch()  
  // try to get filters from context
  const { group = '', car = '' } = getContextOptions( useSelector( getOptions ), context )
  // other selectors
  const cars = useSelector( getCarsDetails )
  const you = useSelector( getYou )
  const favourites = useSelector( getFavourites )

  // get car ids based on group
  const group_cars = group
    ? Object.values( cars ).filter( c => isInGroup( c.num, c.group, group, favourites ) )
    : Object.values( cars )

  const group_cars_nums = group_cars.map( c => c.num )

  // dispatchers
  const onSelect = value => 
  {
    dispatch( setOption( 'car', value, context ) )
    if ( onChange ) onChange( value )
  }
  
  // reset car when choosing a different group
  useEffect( () =>
  {
    // optionally reset car dropdown if it doesn't belong to the selected group
    if ( car && group_cars_nums && !group_cars_nums.includes( parseInt( car ) ) )
    {
      dispatch( setOption( 'car', '', context ) )
    }
  }, [ car, group_cars_nums ] ) 

  // add show all option
  if ( showAll ) group_cars.unshift( 'All cars' )

  /**
   *  Render the selected value with the car icon in front
   */
  const renderValue = ( value, item ) =>
  {
    return (
      <React.Fragment>
        <Icon icon="car" className={ car ? 'active' : '' }/> { `Car ${value}` } <Icon icon="arrow-down" className="carret"/>
      </React.Fragment>
    )
  }

  /**
   * Render each menu item, add a class to the current one 
   */
  const renderMenuItem = ( label, item ) =>
  {
    const { data = {} } = item
    const  { model = '', num = label } = data
    
    const component = <React.Fragment>
                        <CarLogo brand={ model }/>
                        <span className="num">{ num }</span>
                        { isFavourite( num, favourites ) && <Icon icon="star" className="favourite"/> }
                      </React.Fragment>
                      
    if ( String( num ) === String( you ) )
    {
      return <div className='you'>{ component } <Icon icon="avatar" /></div>      
    }
    
    return component
  }

  /**
   * Get the data for the dropdown
   */
  const getData = () => 
  {
    return group_cars.map( item =>
    { 
      if ( typeof item === 'string' ) 
      {
        return { value: '', label: item }
      }
      
      // return value and label as the car number; otherwise search doesn't work
      // use renderMenuItem to show more details
      return { 
        data: item,
        value: item.num, 
        label: item.num
      }
    } )
  }

  // render the dropdown
  return (
    <SelectPicker
      className="filter-car"
      data={ getData() }
      appearance="custom" // throws a warning but works to force custom layout
      placement="auto"
      // render the CURRENT value, not each item
      placeholder={ renderValue( '' ) }
      renderValue={ renderValue }
      // render EACH menu item
      renderMenuItem={ renderMenuItem }
      cleanable={ false }
      onChange={ onSelect }
      value={ car ? parseInt( car ) : '' }
      // noCaret={ true }
    />
  )
}

export default CarDropdown